(function() { module.exports = this["wp"]["a11y"]; }());